import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Compound_strength_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/compound_strength_training.svg';
import { ReactComponent as Strength_muscle_buildingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_muscle_building.svg';
import { ReactComponent as Powerlifting_focusedIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/powerlifting_focused.svg';
import { ReactComponent as Functional_strengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_strength.svg';

interface IncreaseStrengthStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  compound_strength_training: <Compound_strength_trainingIcon />,
  powerlifting_focused: <Powerlifting_focusedIcon />,
  functional_strength: <Functional_strengthIcon />,
  strength_muscle_building: <Strength_muscle_buildingIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const IncreaseStrengthStep3: FC<IncreaseStrengthStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const stepData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (item: any) => item.goalId === 'increase_strength',
  );

  const title = stepData?.title;
  const subtitle = stepData?.subtitle;
  const options = stepData?.options
    ? [...stepData.options].sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !stepData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{title}</h2>
      {subtitle && <p className="step-subtitle">{subtitle}</p>}

      <div className="goal-buttons">
        {options.map((option: any) => {
          const icon = iconMap[option.id] || iconMap[option.image] || null;

          return (
            <button
              key={option.id}
              className={`goal-btn ${selectedApproach === option.slug ? 'selected' : ''}`}
              onClick={() => {
                setSelectedApproach(option.slug);
                if (onNext) onNext(option.slug);
              }}
            >
              <div className="goal-icon">{icon}</div>
              <span className="goal-label">{option.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
